__turbopack_context__.v({
  "alertYellow": "KxQHza_alertYellow",
  "applyCode": "KxQHza_applyCode",
  "black": "KxQHza_black",
  "black90": "KxQHza_black90",
  "card": "KxQHza_card",
  "cyan": "KxQHza_cyan",
  "darkStone": "KxQHza_darkStone",
  "fuschiaPunch": "KxQHza_fuschiaPunch",
  "instructions": "KxQHza_instructions",
  "limeSorbet": "KxQHza_limeSorbet",
  "olive100": "KxQHza_olive100",
  "olive20": "KxQHza_olive20",
  "qrCodeImage": "KxQHza_qrCodeImage",
  "qrForm": "KxQHza_qrForm",
  "softBlack": "KxQHza_softBlack",
  "staticQRCode": "KxQHza_staticQRCode",
  "steps": "KxQHza_steps",
  "teal100": "KxQHza_teal100",
  "teal20": "KxQHza_teal20",
  "title": "KxQHza_title",
  "titleContainer": "KxQHza_titleContainer",
  "warmStone": "KxQHza_warmStone",
  "white": "KxQHza_white",
  "wobble": "KxQHza_wobble",
});
